export default "__VITE_ASSET__BHM4utvO__"